module.exports = __webpack_public_path__ + "static/assets/71655cde34ae75f48cb8820abf4b31e7.svg";